import { create } from "zustand";
import type { ColorFormat } from "@/color/oklch";

export type Tool = "generate" | "adjust" | null;
export type DialogId = "export" | "presets" | "shortcuts" | "import" | null;

interface UiState {
  tool: Tool;
  dialog: DialogId;
  palette: boolean;
  /** Format the color pickers show, kept while moving between swatches. */
  colorFormat: ColorFormat;
  openTool: (tool: Tool) => void;
  openDialog: (dialog: DialogId) => void;
  setPalette: (open: boolean) => void;
  setColorFormat: (format: ColorFormat) => void;
}

/** Transient UI state that is not part of the theme or its history. */
export const useUi = create<UiState>()((set) => ({
  tool: null,
  dialog: null,
  palette: false,
  colorFormat: "hex",
  openTool: (tool) => set({ tool }),
  openDialog: (dialog) => set({ dialog }),
  setPalette: (palette) => set({ palette }),
  setColorFormat: (colorFormat) => set({ colorFormat }),
}));
